function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M59.4,57.2H0.9L4.3,17h51.6L59.4,57.2z M4.1,54.2h52L53.2,20H7L4.1,54.2z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M44.4,18.5h-3v-3.2c0-6.2-5-11.3-11.3-11.3s-11.3,5-11.3,11.3v3.2h-3v-3.2c0-7.9,6.4-14.3,14.3-14.3s14.3,6.4,14.3,14.3 V18.5z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 3.5,
  y: 41.5,
  width: 53.1,
  height: 3
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 4.6,
  y: 29.8,
  width: 51,
  height: 3
})))));

var SvgShoppingBag = function SvgShoppingBag(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/shopping-bag.ce0dda0a.svg";
export { SvgShoppingBag as ReactComponent };